import { all } from "redux-saga/effects";
import user from "./user";
import schemes from "./schemes";
import dealers from "./dealers";
import machine from "./machine";

const sagas = function* sagas() {
  yield all([user(), schemes(), dealers(), machine()]);
};

export default sagas;
